/**
 * The header's three figures: `W bibliotece`, `Twoje`, `Z materiałami`.
 *
 * ── Over the WHOLE catalogue, never the filtered view ───────────────────────────────────────
 * The same rule the plan library's band carries. A trainer typing in the search box is narrowing
 * what they are looking at, not changing how many exercises exist — and the canon's own shot reads
 * `477 · 8 · 9` whatever the list below it is showing. A figure that moved with the filter would be
 * a count of nothing anybody asked about, and it would move the header while the trainer typed.
 *
 * ── `Z materiałami` is the RESOLVED links, counted here rather than asked for ────────────────
 * Owner decision D14, 17 September 2026: it counts exercises whose links array is non-empty as
 * `GET /exercise` returns them — the library's own links and this trainer's overlays alike, because
 * that is what the trainer will actually find on the card. There is no backend field for it and
 * none is being asked for: the catalogue is already in the browser, fully described, so the count
 * is a loop over an array that has already been fetched.
 *
 * ── Three figures, and they are UNKNOWN together ────────────────────────────────────────────
 * All three fold from one read, so there is no state where some are known. `null` is the whole
 * answer while it is open or after it failed, and `ScreenHeader` draws an em dash for it — a zero
 * beside a failure would be three false statements about the trainer's own account.
 */

/** What a movement carries, as far as these three figures are concerned. */
interface Countable {
  readonly isCustom: boolean;
  readonly links: readonly unknown[];
}

export interface ExerciseHeaderStats {
  readonly library: number;
  readonly own: number;
  readonly withMaterials: number;
}

export function exerciseHeaderStats(
  items: readonly Countable[] | null,
): ExerciseHeaderStats | null {
  if (items === null) return null;

  let own = 0;
  let withMaterials = 0;
  for (const item of items) {
    if (item.isCustom) own += 1;
    if (item.links.length > 0) withMaterials += 1;
  }
  return { library: items.length - own, own, withMaterials };
}
